import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

/** Create/rename modal for a single folder. `folderDialog` is null while the dialog is closed. */
const FolderDialog = ({ folderDialog, onChangeName, onClose, onSave, saving }) => (
  <Dialog open={Boolean(folderDialog)} onClose={onClose} fullWidth maxWidth="xs">
    <DialogTitle>{folderDialog?.mode === "rename" ? "Rename folder" : "New folder"}</DialogTitle>
    <DialogContent>
      <TextField
        autoFocus
        fullWidth
        margin="dense"
        label="Folder name"
        value={folderDialog?.name || ""}
        onChange={(event) => onChangeName(event.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button variant="contained" disabled={!folderDialog?.name?.trim() || saving} onClick={onSave}>
        Save
      </Button>
    </DialogActions>
  </Dialog>
);

export default FolderDialog;
